import { useEffect } from "react";
import { api } from "@/lib/api";

const visitorId = () => {
  let id = localStorage.getItem("esc_vid");
  if (!id) {
    id = (crypto.randomUUID?.() || `${Date.now()}-${Math.random()}`).replace(/[^a-zA-Z0-9-]/g, "");
    localStorage.setItem("esc_vid", id);
  }
  return id;
};

export function usePageTracking(pathname, lang) {
  useEffect(() => {
    if (localStorage.getItem("esc_owner") === "1" || navigator.webdriver) return;
    const first = !sessionStorage.getItem("esc_session");
    sessionStorage.setItem("esc_session", "1");
    api.post("/track", { vid: visitorId(), path: pathname, lang, referrer: first ? document.referrer : "internal" }).catch(() => {});
  }, [pathname, lang]);
}
